<script setup lang="ts">
import { SEND_REQUEST_PAGE_URL } from '@/constants';
import { DgrIcon, DgrPopover } from '@stockmarkteam/donguri-ui';
import { featureFlags } from '@/featureFlags';

defineProps<{
  supportLink?: string;
}>();

const dropdownZIndex = Number(
  // ヘッダーよりも上に表示する
  getComputedStyle(document.body).getPropertyValue('--z-header') + 1,
);
</script>
<template>
  <DgrPopover :z-index="dropdownZIndex">
    <template #default="{ triggerProps }">
      <button
        v-bind="triggerProps"
        v-tooltip="{ content: 'ヘルプを開く', triggers: ['hover'] }"
        type="button"
        class="help-menu"
      >
        <DgrIcon name="question-circle" class="icon" />
      </button>
    </template>
    <template #content="{ close }">
      <div class="help-dropdown c-text-regular--m">
        <a
          :href="supportLink || 'https://anews-stockmark.zendesk.com/hc/ja'"
          target="_blank"
          rel="noopener noreferrer"
          @click="close"
          class="dropdown-item"
        >
          {{
            featureFlags.ANDEV_9844_HELP_MENU_RENEWAL
              ? 'ヘルプページ'
              : 'サポート'
          }}
        </a>
        <a
          v-if="featureFlags.ANDEV_9844_HELP_MENU_RENEWAL"
          :href="SEND_REQUEST_PAGE_URL"
          target="_blank"
          rel="noopener noreferrer"
          @click="close"
          class="dropdown-item"
        >
          お問い合わせ
        </a>
        <slot name="dropdown-items" />
      </div>
    </template>
  </DgrPopover>
</template>
<style scoped lang="scss">
.help-menu {
  &:hover {
    background: $color-gray200;
  }

  border: none;
  background: none;

  width: 32px;
  height: 32px;
  padding: 4px;
}

.help-dropdown {
  box-shadow: 0px 1px 5px rgba($color-gray1000, 0.25);
  border-radius: 4px;
  padding: 12px 0;

  display: flex;
  flex-direction: column;
  gap: 8px;

  .dropdown-item {
    padding: 4px 12px;

    &:hover {
      background: $color-gray200;
    }
  }

  .dropdown-divider {
    border-top: 1px solid $color-gray400;
    border-bottom: 0;
  }
}

.icon {
  width: 24px;
  height: 24px;
}
</style>
